// ════════════════════════════════════════════════════════════════
//  الموقع بعد إغلاق الحجز والإدارة على الويب (٤ أكتوبر ٢٠٢٦ — دفعة الأمان)
//
//  ⚠️ قرار المالك: الويب ملغى والتطبيقان وحدهما. كان هذا الملف (~٩٢٠٠ سطر) حجز
//  العميل ولوحتي الفني والمدير على الويب: يكتب في Firestore مباشرة، ويرسل
//  EmailJS من المتصفح، وينادي send-otp/verify-otp/admin-login/validate-promo.
//  كله أُزيل (وحُذف ordersService.js وfirebase.js) — في تاريخ git لمن أراده.
//
//  الآن: أي مسار (/ · /booking · /admin · #admin-…) يعرض إشعاراً واحداً بلا
//  شبكة ولا قراءة ولا كتابة: «الحجز صار من تطبيق PrimeFix» + واتساب.
//  الصفحات الثابتة (promo.html · privacy-policy.html) وapi/u.js باقية كما هي.
// ════════════════════════════════════════════════════════════════

const WHATSAPP_NUMBER = "966500095121";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("السلام عليكم، أبي أحجز خدمة صيانة")}`;

const css = `
  .pfn { --ground:#FBF8F5; --ink:#1A1613; --slate:#6F665F; --ember:#D94E08; --edge:rgba(26,22,19,.08); }
  @media (prefers-color-scheme: dark) {
    .pfn { --ground:#100D0B; --ink:#F7F3EF; --slate:#8F857C; --edge:rgba(255,255,255,.1); }
  }
  .pfn { min-height:100vh; box-sizing:border-box; display:flex; align-items:center; justify-content:center;
    background:var(--ground); color:var(--ink); direction:rtl;
    font-family:-apple-system, "SF Arabic", "Cairo", system-ui, sans-serif; }
  .pfn main { width:100%; max-width:420px; padding:32px 20px; text-align:center; }
  .pfn img { width:84px; height:84px; border-radius:22px; }
  .pfn h1 { font-size:22px; font-weight:600; margin:18px 0 8px; }
  .pfn p { color:var(--slate); font-size:15px; font-weight:400; line-height:1.7; margin:0 0 8px; text-wrap:balance; }
  .pfn .soon { display:inline-block; margin:8px 0 26px; padding:6px 14px; border:1px solid var(--edge);
    border-radius:999px; font-size:13px; font-weight:600; color:var(--ink); }
  .pfn a.btn { display:block; padding:16px; border-radius:999px; font-size:16px; font-weight:600;
    text-decoration:none; margin-bottom:12px; }
  .pfn .cta { background:var(--ember); color:#fff; }
  .pfn .quiet { border:1px solid var(--edge); color:var(--ink); }
  .pfn small { display:block; margin-top:22px; color:var(--slate); font-size:12px; }
  .pfn small a { color:var(--slate); }
`;

export default function App() {
  return (
    <div className="pfn" dir="rtl" lang="ar">
      <style>{css}</style>
      <main>
        <img src="/logo192.png" alt="PrimeFix" />
        <h1>الحجز صار من تطبيق PrimeFix</h1>
        <p>احجز موعدك وتابع طلبك من التطبيق — صيانة بأيدٍ أمينة.</p>
        <span className="soon">قريباً على المتجرين</span>
        <a className="btn cta" href={WHATSAPP_URL}>تواصل عبر واتساب</a>
        <a className="btn quiet" href={`tel:+${WHATSAPP_NUMBER}`}>اتصل بنا</a>
        <small><a href="/privacy-policy.html">سياسة الخصوصية</a></small>
      </main>
    </div>
  );
}
